"use strict";
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemRemovalExclusion = void 0;
var ItemRemovalExclusion = /** @class */ (function () {
    function ItemRemovalExclusion() {
        this._itemIds = new Set();
    }
    ItemRemovalExclusion.prototype.add = function (id) {
        this._itemIds.add(id);
    };
    ItemRemovalExclusion.prototype.remove = function (id) {
        this._itemIds.delete(id);
    };
    Object.defineProperty(ItemRemovalExclusion.prototype, "ids", {
        get: function () {
            return Array.from(this._itemIds.values());
        },
        enumerable: false,
        configurable: true
    });
    return ItemRemovalExclusion;
}());
exports.ItemRemovalExclusion = ItemRemovalExclusion;
//# sourceMappingURL=ItemRemovalExclusion.js.map